// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"b8515613","425":"996f7f18","510":"d1bfa895","532":"414d80e7","633":"e2c636d0","634":"8ba5b148","922":"c1b8e114","937":"925b2332","972":"6eb54b4d"}[chunkId] + ".chunk.js";
};